export const STUDENT_TABS = Object.freeze(["chart", "consults"]);
export const PAYMENT_TABS = Object.freeze(["all", "untouched", "billing", "paid", "retry"]);
export const ACADEMY_TABS = Object.freeze(["subjects", "teachers", "instructors", "schools"]);

export function selectedTab(value, fallback, available) {
  return typeof value === "string" && available.includes(value) ? value : fallback;
}
